export default {
  SELECT_NAV_MENU: 'SELECT_NAV_MENU',
  SELECT_DATE: 'SELECT_DATE',
  SET_CHANNEL_LIST: 'SET_CHANNEL_LIST',
  CREATE_VIDEO: 'CREATE_VIDEO',
  UPDATE_SEARCH_CONDITION: 'UPDATE_SEARCH_CONDITION',
  UPDATE_CHANNEL_LIST_INDEX : 'UPDATE_CHANNEL_LIST_INDEX',
  SHOW_VIDEO : 'SHOW_VIDEO',
  SHOW_MODAL: 'SHOW_MODAL',
  SHOW_DETAIL: 'SHOW_DETAIL',
  SHOW_USER: 'SHOW_USER',
  SET_VIDEO_SOUND_ITEM: 'SET_VIDEO_SOUND_ITEM',
  SET_VIDEO_TYPE: 'SET_VIDEO_TYPE',
  UPDATE_LOG_CONDITION: 'UPDATE_LOG_CONDITION',
  SET_MARKIN_TC: 'SET_MARKIN_TC',
  SET_MARKOUT_TC: 'SET_MARKOUT_TC',
  SET_NOTICE: 'SET_NOTICE'
};


// WEBPACK FOOTER //
// ./src/actions/ActionType.js